<template>
    <div>
        <img
            class="loading-img"
            src="https://abroad-sin-static.shengqugames-corp.com/wpay/icon_loading.png"
            alt="loading"
        />
    </div>
</template>

<script>
import { handleTCaptcha } from '@/lib/utils';

export default {
    data() {
        return { web_pageid: 'captcha-open', platform: 0 };
    },
    mounted() {
        // platform：调用方，用以决定和webview交互接口判断
        // 0：pc unity，部分ios等，接口使用 window.AuthCallback
        // 1: 部分安卓，海外邮箱登录， 接口使用 window.jsBridge.AuthCallback
        const { captchaParams, platform } = this.$route.query;

        this.platform = platform;

        if (captchaParams) {
            handleTCaptcha(
                JSON.parse(captchaParams || '{}')?.tyData?.appId,
                this.handleTCaptchaSuccess,
                this.handleTCaptchaError
            );
        } else {
            try {
                this.handleWebviewCallback({ code: -1001, msg: 'params error', data: {} });
            } catch (error) {
                console.log(error);
            }
        }
    },
    methods: {
        handleTCaptchaSuccess(res) {
            try {
                this.handleWebviewCallback({ code: 0, msg: '', data: res });
            } catch (error) {
                console.log(error);
            }
        },
        handleTCaptchaError(error) {
            try {
                this.handleWebviewCallback({ code: -1002, msg: 'load error', data: error });
            } catch (err) {
                console.log(err);
            }
        },
        handleWebviewCallback(data) {
            switch (this.platform) {
                case '0':
                    setTimeout(() => {
                        try {
                            window.AuthCallback(data || {});
                        } catch (e) {
                            console.error(e);
                        }
                    }, 800);
                    break;
                case '1':
                    setTimeout(() => {
                        try {
                            window.jsBridge.AuthCallback(JSON.stringify(data || {}));
                        } catch (e) {
                            console.error(e);
                        }
                    }, 800);
                    break;
                default:
                    break;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.loading-img {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 50px;
}
</style>
<style lang="scss">
html,
.index {
    background-color: #fff !important;
}
</style>
